<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12"  style="margin-top:100px">
          <v-layout justify-center>
            <v-flex lg4 md4 sm8 xs12>
              <div class="layout column align-center">
                <img alt="Vue Material Admin" src="../assets/osa.png" class="logoStyle">
              </div>
            </v-flex>
          </v-layout>

        </v-col>
      </v-row>
      <v-row >
        <v-col cols="12">
          <v-container fluid>
            <v-layout  justify-center>
              <v-flex lg4 md4 sm8 xs12>
                <ValidationObserver ref="obs" v-slot="{  passes }">
                  <v-card class="elevation-1 pa-3" style="border-top: 3px solid red">
                    <v-card-text>
                      <div class="layout column align-center">
                        <img alt="Vue Material Admin" src="../assets/eInsights.png" class="eInsightsLogoStyle">
                      </div>

                      <v-form>
                        <ValidationProvider rules="required" name="username"
                                            v-slot="{ errors, valid, failedRules }">
                          <v-text-field append-icon="$vuetify.icons.values.mdiAccount" required
                                        :label="$t('msg.username_label')" name="username"
                                        type="text"
                                        autocomplete="new-password"
                                        :error-messages="$translatedErrorMessages(failedRules,'username')"
                                        :success="valid"
                                        id="username" v-model="username"
                                        v-on:keyup.enter="passes(login)"/>
                        </ValidationProvider>

                        <ValidationProvider rules="required" name="password"
                                            v-slot="{  valid, failedRules }">
                          <v-text-field append-icon="$vuetify.icons.values.mdiLock" :label="$t('msg.password_label')"
                                        name="password"
                                        type="password"
                                        autocomplete="new-password"
                                        :error-messages="$translatedErrorMessages(failedRules,'password')"
                                        :success="valid"
                                        id="password" v-model="password"
                                        v-on:keyup.enter="passes(login)"/>
                        </ValidationProvider>
                        <v-spacer/>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer> </v-spacer>
                      <v-btn color="error" @click="login">
                        {{$t('msg.login_button')}}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </ValidationObserver>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-snackbar
                v-model="error"
                :timeout="timeout"
                color="error"
                right
                top
        >
          Invalid Username or Password
        </v-snackbar>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  export default {
    name: 'Login',
    components: {
      // Header,
      // Footer,
      ValidationProvider,
      ValidationObserver
    },
    data () {
      return {
        snackbar: false,
        username: '',
        password: '',
        timeout: 3000,
        hidePassword: true,
        loading: false,
        error: false,
        result: '',
        showResult: false,
        invalidUserCredentials: false
      }
    },
    methods: {
      login: function () {
        if (this.username !== '' && this.password !== ''){
          this.$router.push('/dashboard')
        }
       else {
         this.error = true
        }
      }
    }
  }
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  .logoStyle{
    height: 100px;
  }
  .eInsightsLogoStyle{
    width: 316px;
    height: 100px;
  }
  .v-application a{
    color: #000;
    text-decoration: none;
    opacity: .5;
  }
  .v-application a:hover{
    opacity: 1;
    text-decoration: underline;
  }
</style>
